<ng-container *transloco="let t">
  <app-admin-actions-header [isXlsVisible]="false" [isPdfVisible]="false">
    <div slot="leadingWidgets">
      <app-rounded-button [label]="t('app.common.add')" (onClick)="openAddNewUserModal()"
                          [btnClass]="'rounded-button--solid'"><i
        class="bi bi-plus-circle pe-2"></i></app-rounded-button>
    </div>
  </app-admin-actions-header>

  @if (users && users.length > 0) {
    <div>
      <div class="table-responsive d-xl-block d-none">
        <app-sortable-table cssClass="table dark-header table-last-row-no-border" infinite-scroll
                            [infiniteScrollDistance]="4"
                            [items]="users" [infiniteScrollThrottle]="environment.fullTextSearchDelay">
          <thead>
          <tr>
            <th scope="col" [sortBy]="['firstname','lastname']">{{ t("app.common.name.surname") }}</th>
            <th scope="col" [sortBy]="['email']" class="email-column-width">{{ t("app.common.email") }}</th>
            <th scope="col" [sortBy]="['username']">{{ t("app.common.username") }}</th>
            <th scope="col" [sortBy]="['role']" class="role-column-width">{{ t("app.common.role") }}</th>
            <th scope="col" [sortBy]="['phoneNumber']" class="phone-column-width">{{ t("app.common.mobilePhone") }}</th>
            <th class="icon-column-width"></th>
          </tr>
          </thead>
          <tr app-table-header-separator></tr>
          <tbody>
            @for (user of users;track user) {
              <tr>
                <td class="center-align">{{ user.firstname ?? "" }} {{ user.lastname ?? "" }}</td>
                <td class="center-align" matTooltip="{{user.email ?? '-'}}">
                  @if (user.email) {
                  <a class="text-black" href="mailto:{{user.email}}" target="_blank"
                       rel="noopener noreferrer">{{ user.email }}</a>
                  } @else {
                  -
                  }
                </td>
                <td class="center-align">{{ user.username ?? "" }}</td>
                <td class="center-align">
                  <div class="status-badge" [ngClass]="{'accepted': user.role === ORGANIZER_ROLE,
                       'on-hold': user.role === HELPER_ROLE, 'publishing': user.role === USER_ROLE
                       }">
                <span class="fw-semibold">
                  {{ user.role | role | uppercase }}
                </span>
                  </div>
                </td>
                <td class="center-align">
                  @if (user.phoneNumber) {
                  <a class="text-black" href="tel:{{user.phoneNumber}}">{{ user.phoneNumber }}</a>
                  } @else {
                  -
                  }
                </td>
                <td class="text-end center-align h-100">
                  @if (currentUserDetails?.userId !== user.userId &&
                  (isAdmin || user.userId !== currentOrganiser?.userId)) {
                  <div ngbDropdown class="dropdown dropdown--remove-arrow" container="body">
                      <span class="menu-icon" id="eventActionsDropdown" ngbDropdownToggle>
                          <i class="fas fa-ellipsis-v"></i>
                      </span>
                      <ul aria-labelledby="eventActionsDropdown" ngbDropdownMenu>
                        <li ngbDropdownItem (click)="openEditUserModal(user)">{{ t("app.common.edit") }}</li>
                        <li ngbDropdownItem (click)="openDeleteUserDialog(user)">{{ t("app.common.delete") }}</li>
                      </ul>
                    </div>
                  }
                </td>
              </tr>
            }
          </tbody>
        </app-sortable-table>
      </div>
      <!--      Mobile table-->
      @for (user of users;let isLast=$last;track user) {
        <div class="d-block d-xl-none">
          <div class="d-flex justify-content-center align-items-center mobile-table-row" [class.isLastRow]="isLast">
            <div class="flex-grow-1">
              <div class="d-flex flex-column" [class.isLastRow]="isLast">
                <div>
                  <strong>{{ t("event.item.id") }}:</strong> {{ user.id }}
                </div>
                <div>
                  <strong>{{ t("app.common.first.name") }}:</strong> {{ user.firstname ?? "-" }}
                </div>
                <div>
                  <strong>{{ t("app.common.last.name") }}:</strong> {{ user.lastname ?? "-" }}
                </div>
                <div>
                </div>
                <div>
                  <strong>{{ t("app.common.mobilePhone") }}:</strong> {{ user.phoneNumber ?? "-" }}
                </div>
                <div>
                  <strong>{{ t("app.common.email") }}:</strong> {{ user.email ?? "-" }}
                </div>
                <div>
                  <strong>{{ t("app.common.role") }}:</strong> {{ user.role | role }}
                </div>
              </div>
            </div>
            <div>

              @if (currentUserDetails?.userId !== user.userId &&
                  (isAdmin || user.userId !== currentOrganiser?.userId)) {
                <div ngbDropdown class="dropdown dropdown--remove-arrow" container="body">
            <span class="menu-icon" id="eventActionsDropdownMobile" ngbDropdownToggle>
              <i class="fas fa-ellipsis-v"></i>
            </span>
                  <ul aria-labelledby="eventActionsDropdownMobile" ngbDropdownMenu>
                    <li ngbDropdownItem (click)="openEditUserModal(user)">{{ t("app.common.edit") }}</li>
                    <li ngbDropdownItem (click)="openDeleteUserDialog(user)">{{ t("app.common.delete") }}</li>
                  </ul>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  } @else {
    <app-empty-state-admin/>
  }

</ng-container>
